import React from 'react';
import { useParams } from 'react-router';

import CommunityInfo from './CommunityInfo';
import SnapshotProvider from '../../common/Snapshot/SnapshotContext';

const CommunityInfoRoot = () => {
  const { communityId, competitorId } = useParams();
  const id = Number(competitorId || communityId);

  return (
    <SnapshotProvider communityId={id ?? 0}>
      <CommunityInfo />
    </SnapshotProvider>
  );
};

export default CommunityInfoRoot;
